import Icon from '../components/Icon.vue'

Icon.register({
  'wave-square': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M476 480h-152c-19.9 0-36-16.1-36-36v-348h-96v156c0 19.9-16.1 36-36 36h-140c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h112v-156c0-19.9 16.1-36 36-36h152c19.9 0 36 16.1 36 36v348h96v-156c0-19.9 16.1-36 36-36h140c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-112v156c0 19.9-16.1 36-36 36z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/wave-square.js
// module id = 2105
// module chunks = 0